import React from 'react';
import { getComputedCSSVariable } from '../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const FlagEmptySVG: React.FC<Props> = ({
  color,
  style,
}) => {
  return (
    <div
      className="d-flex svg-wrapper"
      style={style}
    >
      <svg id="noun_Flag_1279072" xmlns="http://www.w3.org/2000/svg" width="7.152" height="10.227" viewBox="0 0 7.152 10.227">
        <g id="noun_Flag_1279072-2" data-name="noun_Flag_1279072" transform="translate(-18.81 -5.39)" fill="none">
          <path d="M25.709,6.777a.8.8,0,0,0-.55-1.387H19.154a.344.344,0,0,0-.344.344v9.539a.344.344,0,1,0,.688,0V11.246h5.66a.8.8,0,0,0,.551-1.387L24.159,8.4a.115.115,0,0,1,0-.167Z" stroke="none" />
          <path d="M 19.81000518798828 6.389996528625488 L 19.81000518798828 10.24602699279785 L 24.66098403930664 10.24602699279785 L 23.47602462768555 9.131176948547363 C 23.25174522399902 8.921236991882324 23.12311363220215 8.624636650085449 23.12311363220215 8.317436218261719 C 23.12311363220215 8.010236740112305 23.25174522399902 7.71364688873291 23.47445487976074 7.505176544189453 L 24.66070175170898 6.389996528625488 L 19.81000518798828 6.389996528625488 M 25.15949440002441 5.389996528625488 C 25.4883918762207 5.390002250671387 25.78401947021484 5.590733528137207 25.90531539916992 5.896486282348633 C 26.02668380737305 6.202436447143555 25.94889450073242 6.55147647857666 25.70908546447754 6.77692699432373 L 24.15940475463867 8.233766555786133 C 24.13625526428223 8.255436897277832 24.12311363220215 8.285726547241211 24.12311363220215 8.317436218261719 C 24.12311363220215 8.349146842956543 24.13625526428223 8.379446983337402 24.15940475463867 8.401116371154785 L 25.7090950012207 9.85910701751709 C 25.94904518127441 10.08469676971436 26.02676391601562 10.43401622772217 25.90510368347168 10.74006652832031 C 25.78344345092773 11.0461254119873 25.48652458190918 11.2464542388916 25.15775489807129 11.24602699279785 L 19.49773406982422 11.24602699279785 L 19.49773406982422 15.27269649505615 C 19.49773406982422 15.46260643005371 19.34377479553223 15.61655616760254 19.15386390686035 15.61655616760254 C 18.96395492553711 15.61655616760254 18.81000518798828 15.46260643005371 18.81000518798828 15.27269649505615 L 18.81000518798828 5.733866691589355 C 18.81000518798828 5.543956756591797 18.96395492553711 5.389996528625488 19.15386390686035 5.389996528625488 L 25.15890502929688 5.389996528625488 C 25.15910530090332 5.389996528625488 25.15929412841797 5.389996528625488 25.15949440002441 5.389996528625488 Z" stroke="none" fill={color} />
        </g>
      </svg>

    </div>
  );
};

FlagEmptySVG.defaultProps = {
  color: getComputedCSSVariable('warning'),
  style: {
    width: '15px',
    height: '15px',
  },
};

export default FlagEmptySVG;
